import type { LngLat } from "./snapPoint";

function orient(a: LngLat, b: LngLat, c: LngLat): number {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

function onSeg(a: LngLat, b: LngLat, p: LngLat): boolean {
  return (
    Math.min(a[0], b[0]) - 1e-12 <= p[0] &&
    p[0] <= Math.max(a[0], b[0]) + 1e-12 &&
    Math.min(a[1], b[1]) - 1e-12 <= p[1] &&
    p[1] <= Math.max(a[1], b[1]) + 1e-12
  );
}

function segmentsIntersect(a: LngLat, b: LngLat, c: LngLat, d: LngLat): boolean {
  const o1 = orient(a, b, c);
  const o2 = orient(a, b, d);
  const o3 = orient(c, d, a);
  const o4 = orient(c, d, b);
  if (o1 === 0 && onSeg(a, b, c)) return true;
  if (o2 === 0 && onSeg(a, b, d)) return true;
  if (o3 === 0 && onSeg(c, d, a)) return true;
  if (o4 === 0 && onSeg(c, d, b)) return true;
  return o1 * o2 < 0 && o3 * o4 < 0;
}

/** Проверка кольца на самопересечения (без учёта касания в общей вершине соседних рёбер). */
export function ringHasSelfIntersection(ring: LngLat[]): boolean {
  const n = ring.length;
  if (n < 4) return false;
  const closed =
    ring[0][0] === ring[n - 1][0] && ring[0][1] === ring[n - 1][1]
      ? ring
      : [...ring, ring[0]];
  const m = closed.length - 1;
  for (let i = 0; i < m; i++) {
    for (let j = i + 1; j < m; j++) {
      if (Math.abs(i - j) <= 1) continue;
      if (i === 0 && j === m - 1) continue;
      if (
        segmentsIntersect(closed[i], closed[i + 1], closed[j], closed[j + 1])
      ) {
        return true;
      }
    }
  }
  return false;
}

export function validatePolygonCoords(
  coordinates: LngLat[],
): { ok: true } | { ok: false; reason: string } {
  if (coordinates.length < 3) {
    return { ok: false, reason: "Нужно минимум 3 вершины" };
  }
  if (ringHasSelfIntersection(coordinates)) {
    return { ok: false, reason: "Полигон самопересекается" };
  }
  return { ok: true };
}
